export const MODULATOR_LAST_POINT_CHART_CARD_FRENCH_LOCALE = {
  title: "Dernier point reçu",
};
